export const GET_ALL_RESTAURANTS = 'get_all_restaurants';
export const ADD_RESTAURANT = 'add_restaurant';
export const UPDATE_RESTAURANT = 'update_restaurant';
export const DELETE_RESTAURANT = 'delete_restaurant';
export const GET_REGIONS = 'get_regions';
